import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import {RuntimeConfigEnvironment} from "../interface/environment.interface";
import {environment} from "../environment";




@Injectable({ providedIn: 'root' })
export class ConfigService {
  private http = inject(HttpClient);

  public async loadConfig(): Promise<void> {
    try {
      const config = await firstValueFrom(
        this.http.get<RuntimeConfigEnvironment>('./environments/config/config.json')
      );
      // 1. config существует и является объектом
      // 2. config не пустой (в нем есть хотя бы один ключ)
      if (!config || Object.keys(config).length === 0) {
        Object.assign(environment, await firstValueFrom(
          this.http.get<RuntimeConfigEnvironment>('./environments/config/config-local.json')
        ));
        return;
      }
      Object.assign(environment, config);
    } catch (err) {
      // 1. файл недоступен (404, 500, CORS, нет сети)
      // 2. файл содержит некорректный JSON (SyntaxError)
      this.showErrorScreen();
      return Promise.reject(err);
    }
  }

  private showErrorScreen(): void {
    document.body.innerHTML = `
    <div class="inner-section error">
<div class="notfound">
  <h1>Сайт временно недоступен</h1>
<p class="din-pro-simple-text sub-title-margin">
  Не удалось загрузить конфигурацию приложения.
</p>
<a href="${environment.portalOnfUrl || 'https://onf.ru'}" class="button active">
  <span class="message-error">вернуться на главную</span></a>
</div>
</div>
  `;
  }




}

